import { styled } from '@linaria/react';
import { Text } from '../typography/typography';

interface Props extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode | string;
}

export const Link = ({ href, children, ...props }: Props) => {
  const content =
    typeof children === 'string' ? (
      <Text size="small" weight="medium">
        {children}
      </Text>
    ) : (
      children
    );

  return (
    <StyledLink href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {content}
    </StyledLink>
  );
};

const StyledLink = styled.a<Props>`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: var(--secondary-light);

  &:hover {
    color: var(--secondary-darkest);
    cursor: pointer;
  }
`;
